import '../style/switch-button-DVC8gEeB.css'
import { defineComponent as g, useCssVars as I, useModel as N, toRefs as E, ref as n, computed as o, watch as O, openBlock as u, createElementBlock as p, normalizeClass as d, unref as _, createElementVNode as S, normalizeStyle as z, Fragment as K, renderList as L, withDirectives as M, withKeys as T, renderSlot as W, createTextVNode as D, toDisplayString as j, createCommentVNode as A } from "vue";
import { useResizeObserver as F } from "@vueuse/core";
import { useElementVisibility as P } from "./hooks/useElementVisibility.js";
import q from "./directives/ripple.js";
import { getSpacingVariableByValue as G } from "./utils/style.js";
import { useComponentClassList as H } from "./hooks/useComponentClassList.js";
const J = ["onClick", "onKeydown"], w = "e-switch-button", te = /* @__PURE__ */ g({
  name: w,
  __name: "switch-button",
  props: {
    modelValue: {},
    space: {},
    ripple: { type: [Boolean, Object] },
    disabled: { type: Boolean },
    variant: {},
    items: {}
  },
  setup(b) {
    I((e) => ({
      "45d1f94f": k.value
    }));
    const t = b, m = N(t, "modelValue"), { disabled: V } = E(t), l = n(null), x = H(w, {
      variant: t.variant,
      disabled: V
    }), i = n(null), a = n(!1), r = n(0), C = P(l);
    F(l, (e) => {
      f();
    });
    const B = o(() => t.items.length);
    function f() {
      if (i.value) {
        const e = i.value[0];
        r.value = e.clientWidth;
      }
    }
    O(C, (e) => {
      e ? (setTimeout(() => {
        a.value = !0;
      }, 300), f()) : a.value = !1;
    });
    const v = o(() => t.items.findIndex((e) => e.value === m.value)), k = o(() => G(t.space ?? 0)), R = o(() => {
      const e = t.space ?? 0, y = r.value * v.value, s = r.value, c = e ? `calc(100% - ${2 * e}px)` : "100%";
      return {
        transform: `translate3d(${y}px, 0, 0)`,
        width: `${s}px`,
        height: c,
        top: `${e}px`,
        left: `${e}px`
      };
    });
    function h(e) {
      t.disabled || (m.value = e.value);
    }
    return (e, y) => B.value > 0 ? (u(), p("div", {
      key: 0,
      ref_key: "switchButtonRef",
      ref: l,
      class: d(_(x))
    }, [
      S("div", {
        class: d(["e-switch-button__slider", {
          "e-switch-button__slider--ready": a.value
        }]),
        style: z(R.value)
      }, null, 6),
      (u(!0), p(K, null, L(e.items, (s, c) => M((u(), p("div", {
        key: s.value,
        ref_for: !0,
        ref_key: "switchButtonItemsRef",
        ref: i,
        role: "button",
        tabIndex: 0,
        class: d(["e-switch-button__item", {
          active: c === v.value
        }]),
        onClick: ($) => h(s),
        onKeydown: T(($) => h(s), ["space", "enter"])
      }, [
        W(e.$slots, "item", { item: s }, () => [
          D(j(s.text), 1)
        ])
      ], 42, J)), [
        [_(q), s.ripple || e.ripple]
      ])), 128))
    ], 2)) : A("", !0);
  }
});
export {
  te as default
};
//# sourceMappingURL=switch-button.js.map
